import {
  CREATE_CHECKOUT_SESSION_REQUEST,
  CREATE_CHECKOUT_SESSION_SUCCESS,
  CREATE_CHECKOUT_SESSION_FAIL,
  SET_CHECKOUT_MANIFEST,
  CLEAR_CHECKOUT_MANIFEST,
  CONFIRM_PAYMENT_REQUEST,
  CONFIRM_PAYMENT_SUCCESS,
  CONFIRM_PAYMENT_FAIL,
  FETCH_PAYMENTS_REQUEST,
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_FAIL,
  FETCH_PAYMENT_DETAILS_REQUEST,
  FETCH_PAYMENT_DETAILS_SUCCESS,
  FETCH_PAYMENT_DETAILS_FAIL,
} from '../actions/payments';

const initialState = {
  loading: false,
  error: null,
  checkoutManifest: null,

  confirming: false,
  confirmResult: null,

  paymentsLoading: false,
  payments: [],          
  paymentsMeta: null,    

  paymentDetailsLoading: false,
  paymentDetails: null,
};

const paymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CHECKOUT_SESSION_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_CHECKOUT_SESSION_SUCCESS:
      return { ...state, loading: false, checkoutManifest: action.payload };
    case CREATE_CHECKOUT_SESSION_FAIL:
      return { ...state, loading: false, error: action.payload };

    case SET_CHECKOUT_MANIFEST:
      return { ...state, checkoutManifest: action.payload };
    case CLEAR_CHECKOUT_MANIFEST:
      return { ...state, checkoutManifest: null };

    case CONFIRM_PAYMENT_REQUEST:
      return { ...state, confirming: true, error: null };
    case CONFIRM_PAYMENT_SUCCESS:
      return { ...state, confirming: false, confirmResult: action.payload };
    case CONFIRM_PAYMENT_FAIL:
      return { ...state, confirming: false, error: action.payload };

    case FETCH_PAYMENTS_REQUEST:
      return { ...state, paymentsLoading: true, error: null };
    case FETCH_PAYMENTS_SUCCESS: {
      const payload = action.payload;
      const list = Array.isArray(payload) ? payload : payload?.data || [];
      return {
        ...state,
        paymentsLoading: false,
        payments: list,
        paymentsMeta: Array.isArray(payload) ? null : payload?.meta || null,
      };
    }
    case FETCH_PAYMENTS_FAIL:
      return { ...state, paymentsLoading: false, error: action.payload };

    case FETCH_PAYMENT_DETAILS_REQUEST:
      return { ...state, paymentDetailsLoading: true, error: null };
    case FETCH_PAYMENT_DETAILS_SUCCESS:
      return { ...state, paymentDetailsLoading: false, paymentDetails: action.payload };
    case FETCH_PAYMENT_DETAILS_FAIL:
      return { ...state, paymentDetailsLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default paymentsReducer;
